import {createReducer, on} from '@ngrx/store';
import {RuleActions} from './rule.actions';
import {initialState} from './rule.state';

export const ruleReducer = createReducer(
  initialState,

  on(RuleActions.public.updateRuleFilter, (state, {filter}) => ({
    ...state,
    filter: filter
  })),

  on(RuleActions.private.loadRulesWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.loadRulesSuccess, (state, {rulesResponseDto}) => {
    const entities = {...state.entities};
    rulesResponseDto.rules.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
      pages: {
        ...state.pages,
        [state.filter!!.page!!]: rulesResponseDto.rules.map((it) => it.id!!),
      },
      totalCount: rulesResponseDto.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.loadRulesFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(RuleActions.public.createOrUpdateRule, (state, props) => ({
    ...state,
  })),

  on(RuleActions.private.createRule, (state, props) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.createRuleSuccess, (state, props) => {
    const entities = {...state.entities};
    entities[props.ruleResponseDto.id!!] = props.ruleResponseDto;

    return {
      ...state,
      entities: entities,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.createRuleFailure, (state, props) => ({
    ...state,
    isLoading: false,
    error: props.error,
  })),

  on(RuleActions.private.updateRuleWithId, (state, props) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.updateRuleSuccess, (state, props) => {
    const entities = {...state.entities};
    entities[props.ruleResponseDto.id!!] = props.ruleResponseDto;

    return {
      ...state,
      entities,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.updateRuleFailure, (state, props) => ({
    ...state,
    isLoading: false,
    error: props.error,
  })),

  on(RuleActions.public.deleteRuleById, (state, props) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.deleteRuleSuccess, (state, props) => {
    const entities = {...state.entities};
    delete entities[props.id];

    return {
      ...state,
      entities: entities,
      // We have no way of handling pages / totalCount from here, so we reset them here and handle the reloading in the respective effect.
      pages: initialState.pages,
      totalCount: initialState.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.deleteRuleFailure, (state, props) => ({
    ...state,
    isLoading: false,
    error: props.error,
  })),

  on(RuleActions.public.loadRuleWithId, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.loadRuleSuccess, (state, props) => {
    const entities = {...state.entities};
    entities[props.ruleResponseDto.id!!] = props.ruleResponseDto;

    return {
      ...state,
      entities,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.loadRuleFailure, (state, props) => ({
    ...state,
    isLoading: false,
    error: props.error,
  })),

  on(RuleActions.private.skipLoadRuleWithExisting, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),

  on(RuleActions.public.updateIsActive, (state) => ({
    ...state,
    error: null,
  })),

  on(RuleActions.private.updateIsActiveSuccess, (state, props) => ({
    ...state,
    error: null,
  })),

  on(RuleActions.private.updateIsActiveFailure, (state, props) => ({
    ...state,
    error: props.error,
  })),

  on(RuleActions.private.loadRulesWithProvidedFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.loadRulesWithProvidedFiltersSuccess, (state, props) => {
    const entities = {...state.entities};
    props.responseDto.rules.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.loadRulesWithProvidedFiltersFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(RuleActions.public.loadAllRulesByFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.loadAllRulesByFiltersSuccess, (state, props) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  }),

  on(RuleActions.private.loadAllRulesByFiltersFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(RuleActions.private.loadNextOfAll, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(RuleActions.private.loadNextOfAllSuccess, (state, props) => {
    const entities = {...state.entities};
    props.rulesResponseDto.rules.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
    };
  }),

  on(RuleActions.private.loadNextOfAllFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),
);
